import { ColumnsType } from "antd/es/table";
import { User } from "@types";
// import dayjs from "dayjs";
import { UserRole } from "../types/User";
import { Translation } from "react-i18next";
import { Typography } from "antd";
import { Search } from "lucide-react";
import { TableFilterDropdown } from "@components";
import { UsersTableActions } from "../components/users/UsersTableActions";

const translateRoles = (roles: UserRole[]) => {
  const translatedRoles = roles.map((role) => {
    switch (role.name) {
      case "Admin":
        return <Translation>{(t) => t("roles.admin")}</Translation>;
      case "DataAnalyst":
        return <Translation>{(t) => t("roles.dataAnalyst")}</Translation>;
      case "QuestionAdmin":
        return <Translation>{(t) => t("roles.questionAdmin")}</Translation>;
      case "TermAdmin":
        return <Translation>{(t) => t("roles.termAdmin")}</Translation>;
      case "ExamAdmin":
        return <Translation>{(t) => t("roles.examAdmin")}</Translation>;
      case "ExamParticipant":
        return <Translation>{(t) => t("roles.examParticipant")}</Translation>;
      default:
        return role.name;
    }
  });
  return (
    <Translation>
      {(t) => translatedRoles.map((element) => (typeof element === "string" ? element : element?.props.children(t))).join(", ")}
    </Translation>
  );
}

export const usersTable: ColumnsType<User> = [
  {
    title: <Translation>{(t) => `${t("table.firstLastName")}`}</Translation>,
    key: "firstName",
    filterSearch: true,
    filterIcon: (filtered: boolean) => (
      <Search style={{ color: filtered ? "#F1B80E" : undefined }} />
    ),
    onFilter: (value: any, record) =>
      `${record.firstName.toLowerCase()} ${record.lastName.toLowerCase()}`.includes(
        value.toLowerCase()
      ),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <TableFilterDropdown
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
        prefixCls={""}
        close={function (): void {
          throw new Error("Function not implemented.");
        }}
        visible={false}
      />
    ),
    render(_, record) {
      return (
        <Typography.Text>
          {record.firstName} {record.lastName}
        </Typography.Text>
      );
    },
  },
  {
    title: <Translation>{(t) => `${t("table.oib")}`}</Translation>,
    dataIndex: "oib",
    key: "oib",
  },
  {
    title: <Translation>{(t) => `${t("table.email")}`}</Translation>,
    dataIndex: "email",
    key: "email",
  },
  // {
  //   title: <Translation>{(t) => `${t("table.dateJoined")}`}</Translation>,
  //   dataIndex: "dateCreated",
  //   key: "dateCreated",
  //   render: (date: string) => {
  //     return dayjs(date).format("D.M.YYYY");
  //   },
  // },
  {
    title: <Translation>{(t) => `${t("table.roles")}`}</Translation>,
    dataIndex: "applicationRoles",
    width: 500,
    key: "roles",
    render: (roles: UserRole[]) => {
      return  translateRoles(roles);
    },
  },
  {
    title: <Translation>{(t) => `${t("table.actions")}`}</Translation>,
    key: "edit",
    render: (_, record) => {
      return <UsersTableActions user={record} />;
    },
  },
];
